module.exports = __webpack_public_path__ + "static/img/story_bg.a404f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/story_bg.png
// module id = osS4
// module chunks = 0